export const _AssignmentStatus = {
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  IN_PROGRESS_OK: 'IN_PROGRESS_OK',
  IN_PROGRESS_STOPPED: 'IN_PROGRESS_STOPPED',
  IN_PROGRESS_INCIDENTS: 'IN_PROGRESS_INCIDENTS',
  IN_PROGRESS_LATE: 'IN_PROGRESS_LATE',
  DONE: 'DONE'
} as const;

export type AssignmentStatus = (typeof _AssignmentStatus)[keyof typeof _AssignmentStatus];
// eslint-disable-next-line no-redeclare
export const AssignmentStatus = _AssignmentStatus;

export const _ItemStatus = {
  PLANNED: 'PLANNED',
  PENDING: 'PENDING',
  RECEIVED_OK: 'RECEIVED_OK',
  RECEIVED_DAMAGED: 'RECEIVED_DAMAGED',
  RECEIVED_MISSING: 'RECEIVED_MISSING',
  PROCESSED_OK: 'PROCESSED_OK',
  PROCESSED_NOT_OK: 'PROCESSED_NOT_OK',
  PROCESSED_SECOND_LIFE: 'PROCESSED_SECOND_LIFE',
  PROCESSED_DAMAGED: 'PROCESSED_DAMAGED',
  PROCESSED_MISSING: 'PROCESSED_MISSING',
  DEPARTED_OK: 'DEPARTED_OK',
  DEPARTED_NOT_OK: 'DEPARTED_NOT_OK',
  DEPARTED_SECOND_LIFE: 'DEPARTED_SECOND_LIFE',
  DEPARTED_DAMAGED: 'DEPARTED_DAMAGED',
  DEPARTED_MISSING: 'DEPARTED_MISSING',
  CORRECTION_OK: 'CORRECTION_OK',
  CORRECTION_NOT_OK: 'CORRECTION_NOT_OK',
  CORRECTION_SECOND_LIFE: 'CORRECTION_SECOND_LIFE',
  CORRECTION_DAMAGED: 'CORRECTION_DAMAGED',
  CORRECTION_MISSING: 'CORRECTION_MISSING'
} as const;

export type ItemStatus = (typeof _ItemStatus)[keyof typeof _ItemStatus];
// eslint-disable-next-line no-redeclare
export const ItemStatus = _ItemStatus;

export const _CompanyType = {
  CLIENT: 'CLIENT',
  FACILITATOR: 'FACILITATOR',
  WORKSHOP: 'WORKSHOP'
} as const;

export type CompanyType = (typeof _CompanyType)[keyof typeof _CompanyType];
// eslint-disable-next-line no-redeclare
export const CompanyType = _CompanyType;

export const _TruckMovementType = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  CORRECTION: 'CORRECTION'
} as const;

export type TruckMovementType = (typeof _TruckMovementType)[keyof typeof _TruckMovementType];
// eslint-disable-next-line no-redeclare
export const TruckMovementType = _TruckMovementType;

export const _TruckVehicleType = {
  BIL: 'BIL',
  SEMI: 'SEMI',
  FORDON: 'FORDON'
} as const;

export type TruckVehicleType = (typeof _TruckVehicleType)[keyof typeof _TruckVehicleType];
// eslint-disable-next-line no-redeclare
export const TruckVehicleType = _TruckVehicleType;

// Comprehensive Role enum including all roles used in the system
export const _Role = {
  ADMIN: 'ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  USER: 'USER'
} as const;

export type Role = (typeof _Role)[keyof typeof _Role];
// eslint-disable-next-line no-redeclare
export const Role = _Role;

// Export individual role constants for compatibility
export type UserRole = Role; // Alias for compatibility with lib/types/core.ts

// ADDING ProjectPermissionLevel ENUM
export const _ProjectPermissionLevel = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  OPERATOR: 'OPERATOR', // New OPERATOR role
  VIEWER: 'VIEWER'
} as const;

export type ProjectPermissionLevel = (typeof _ProjectPermissionLevel)[keyof typeof _ProjectPermissionLevel];
// eslint-disable-next-line no-redeclare
export const ProjectPermissionLevel = _ProjectPermissionLevel;